module.exports = __webpack_public_path__ + "static/media/poster_tkpa9.bfe6e8da.gif";